export const localTimeZoneOffset = new Date().getTimezoneOffset()
